import { memo } from 'react';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalLayout } from 'root/src/client/v2/common/components/RedesignModalLayout';
// Wires the shared `RedesignModalLayout` card to the redesign modal context (v2). The context
// supplies the overlay + enter/exit animation; this just renders the card and its close.
export const RedesignModalShell = memo(({ children, className }) => {
    const { hide, closeable } = useRedesignModal();
    return (<RedesignModalLayout className={className} onClose={closeable ? hide : undefined}>
			{children}
		</RedesignModalLayout>);
});
